import { render } from "./BaseQuillEditor.vue?vue&type=template&id=7245199a"
import script from "./BaseQuillEditor.vue?vue&type=script&lang=js"
export * from "./BaseQuillEditor.vue?vue&type=script&lang=js"

import "./BaseQuillEditor.vue?vue&type=style&index=0&id=7245199a&lang=css"

import exportComponent from "/var/www/admin_web_aaac/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__